import React, { useContext, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { getContratosList } from './components/contratos.services'
import setRedirectUrl from '../../redux/actions/redirection/setRedirectUrl'
import setLogged from '../../redux/actions/logged/setLogged'
import Navbar from '../../components/Navbar'
import DisplayContractsDesktop from './components/Desktop/renderContractsDesktop'
import DisplayContractsMobile from './components/Mobile/renderContractsMobile'
import { useTheme, useMediaQuery } from '@mui/material'
import NoContractsLabel from './components/noContractsLabel'
import Loading from '../../components/Common/Loading'
import Footer from '../Home/components/Footer'
import { ContractDTO } from '../../dto/ContractDTO'
import DialogPago from './components/DialogPago/DialogPago'
import DatosTransferencia from './components/DialogPago/TansferenciaDatos'
import DialogStatusPago from './components/DialogPago/DialogStatusPago'
import useLocal from '../Products/hooks/locals.hook'

const ContratosVendedor: React.FC = (props: any) => {
  const { whppContratos, idLocal } = useLocal(props.logged?.userLogged?.codLocal)
  const [contratosList, setContratosList] = useState<ContractDTO[]>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [openDialogPago, setOpenDialogPago] = useState<boolean>(false)
  const [openDialogTransferencia, setOpenDialogTransferencia] = useState<boolean>(false)
  const [openStatus, setOpenStatus] = useState<boolean>(false)
  const [estadoPago, setEstadoPago] = useState<string>(null)
  const [tipoPago, setTipoPago] = useState<string>(null)
  const [idPagoStatus, setIdPagoStatus] = useState<string>(null)
  const [payload, setPayload] = useState<any>(null)

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  useEffect(() => {
    if (idLocal === 0) return
    const fetchContratos = async () => {
      try {
        setLoading(true)
        const contratosData = await getContratosList(idLocal)
        setContratosList(contratosData)
      } catch (error) {
        console.error('Error fetching contratos:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchContratos()
  }, [idLocal])

  const handleClick = (acciones: any) => {
    if (acciones.tipo === 'PAGO') {
      setPayload(acciones.payload)
      setOpenDialogPago(true)
    } else if (acciones.tipo == 'LINK') window.open(acciones.payload, '_blank')
  }

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    const collectionStatus = searchParams.get('collection_status')
    const paymentType = searchParams.get('payment_type')
    const collectionId = searchParams.get('collection_id')

    const isValid = (value: string | null) => value && value !== 'null' && value !== 'undefined'

    if (isValid(collectionStatus) && isValid(collectionId)) {
      setEstadoPago(collectionStatus)
      setTipoPago(paymentType)
      setIdPagoStatus(collectionId)
      setOpenStatus(true)
      window.history.replaceState({}, document.title, window.location.pathname)
    }
  }, [])

  if (loading || idLocal === 0 || !contratosList) return <Loading />

  return (
    <>
      <Navbar title="Suscripciones" />
      {contratosList.length === 0 ? (
        <NoContractsLabel message="No tienes suscripciones"></NoContractsLabel>
      ) : isMobile ? (
        <DisplayContractsMobile contratosList={contratosList} contactoLocal={whppContratos} handleClick={handleClick} />
      ) : (
        <DisplayContractsDesktop
          contratosList={contratosList}
          contactoLocal={whppContratos}
          handleClick={handleClick}
        />
      )}
      <Footer />
      {payload && (
        <>
          <DialogPago
            open={openDialogPago}
            setOpen={setOpenDialogPago}
            setOpenTransferencia={setOpenDialogTransferencia}
            payload={payload}
          />
          <DatosTransferencia
            open={openDialogTransferencia}
            setOpen={setOpenDialogTransferencia}
            datos={payload.datosTransferencia}
          />
        </>
      )}
      {estadoPago && (
        <DialogStatusPago
          open={openStatus}
          setOpen={setOpenStatus}
          status={estadoPago}
          id={idPagoStatus}
          tipoPago={tipoPago}
        />
      )}
    </>
  )
}

const mapStateToProps = (state: any) => {
  return {
    logged: state.logged,
    theme: state.theme,
    toaster: state.toaster,
    redirection: state.redirection
  }
}

const mapDispatchToProps = {
  setRedirectUrl,
  setLogged
}

export default connect(mapStateToProps, mapDispatchToProps)(ContratosVendedor)
